import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { DashedButton } from 'page/ProfileScreen/basic/DashedButton'
import { SectionTitle } from 'page/ProfileScreen/basic/SectionTitle'
import { CameraPanel } from 'page/ProfileScreen/Selfies/CameraPanel'
import { DefaultSelfies } from 'page/ProfileScreen/Selfies/DefaultSelfies'
import { Selfies } from 'page/ProfileScreen/Selfies/Selfies'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const SelfiesPanel = observer(() => {
  const def = !!opt.options.selfies?.on
  const { camera } = store.profile

  const onHelp = useLatestCallback(() => {
    store.profile.step = 'help'
  })

  return (
    <Vertical gap={12}>
      <Space gap={16} opposite>
        <SectionTitle>
          {camera ? i18n('profile.Selfie') : i18n('profile.Selfies')}
        </SectionTitle>
        <DashedButton onClick={onHelp}>
          {i18n('HowToTakeSelfie')}
        </DashedButton>
      </Space>
      {!camera && (
        <>
          <Typo size={12} secondary>
            {i18n('UploadTwoSelfies')}
          </Typo>
          <Selfies />
          {def && <DefaultSelfies />}
        </>
      )}
      {camera && <CameraPanel />}
    </Vertical>
  )
})
